import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import '../i18n/config';
import { GeneralTime } from '../constants';
import { GeneralAvailabilityDay } from '../types';
import { Day } from './Day';
import { Never } from './Never';

/**
 * @property {boolean?} never - show a "never" button for this time
 */
interface Props {
  availability: GeneralAvailabilityDay[];
  backgroundColor?: string;
  icon: IconDefinition;
  iconColor: string;
  never?: boolean;
  time: GeneralTime;
  title: string;
  deselectTime(time: GeneralTime): void;
  isDaySelected(index: number, time: GeneralTime): boolean;
  isTimeNeverSelected(time: GeneralTime): boolean;
  toggleDay(index: number, time: GeneralTime): void;
}

export const Week = ({
  availability,
  backgroundColor,
  icon,
  iconColor,
  never,
  time,
  title,
  deselectTime,
  isDaySelected,
  isTimeNeverSelected,
  toggleDay,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className='border-b-2 lg:border-0 border-neutral-100 mb-2 select-none'>
      <div className='mb-1'>
        <FontAwesomeIcon icon={icon} className={`${iconColor ?? ''} mr-2 text-xs align-middle`} />
        <span className='text-sm font-bold align-middle'>{title}</span>
      </div>
      <div className='space-x-1.5 se:space-x-[0.4375rem] sm:space-x-2.5'>
        {availability.map((day, i) => (
          <Day
            isDaySelected={isDaySelected}
            toggleDay={toggleDay}
            key={`${day.dayOfWeekId}-${time}`}
            dayId={day.dayOfWeekId}
            index={i}
            time={time}
            label={t(day.labelKey)}
            backgroundColor={backgroundColor}
          />
        ))}
        {never && (
          <Never
            deselectTime={deselectTime}
            isTimeNeverSelected={isTimeNeverSelected}
            time={time}
            backgroundColor={backgroundColor}
          />
        )}
      </div>
    </div>
  );
};
